import styled, { css } from 'styled-components';

import ellipse from '~/common/styled/mixins/ellipsis';
import BadgeNative from '~/components/Badge';
import TextNative from '~/components/Text';
import VersionNative from '~/components/Version';

export const Version = styled(VersionNative)`
  width: max-content;
`;

export const WrapperVersion = styled.span`
  width: max-content;
`;

export const Badge = styled(BadgeNative)`
  margin-left: ${props => props.theme.spacings.bit};
`;

export const Text = styled(TextNative)`
  ${props =>
    props.type === 'secondary' &&
    css`
      color: ${props.theme.colors.gra600};
    `};
`;

export const Ellipse = styled(TextNative)`
  ${ellipse('180px')}
`;

export const WrapperButtonIcon = styled.span`
  display: flex;
`;
